import * as yup from 'yup';
import { BlockConfigurationSchema } from '.';
import { BlockGroupSchema } from './block';
import { DashboardInfoSchema, UiSettingsSchema } from './dashboard';
export const DashboardDbValueSchema = yup.array().of(DashboardInfoSchema);
export const BlockGridDbValueSchema = yup.object({
    blocks: yup.array().of(BlockConfigurationSchema),
    groups: yup.array().of(BlockGroupSchema),
});
export const UiSettingsDbValueSchema = UiSettingsSchema;
//# sourceMappingURL=db.js.map